import React from 'react'
import {connect} from 'react-redux'
import underscore from 'underscore'
import xml2map from 'xml2map'
//import iconv from 'iconv-lite'
//import {Buffer as buffer} from 'buffer'
import lodash from 'lodash'
import {fetchClient, setB2bCompanySubModule, setB2bCompanyOpened, fetchB2bCompanyPolicyActions,
	setB2bCompanySelectedPolicy, fetchB2bCompanyPolicyActionsDict, setB2bCompanyClientSubAction,
	setB2bCompanyClientAction, B2bCompanyStartB2BAction, B2bCompanyB2bActionRecup, setNotification,
	getB2bCompanyB2BTransactions, fetchExistingClient} from 'state/actions'
import styles from './b2bCompanyClientZoom.scss'
import B2bCompanyClientProfile from './b2bCompanyClientProfile'
import B2bCompanyClientContracts from './b2bCompanyClientContracts'
import B2bCompanyClientActionSelector from './b2bCompanyClientActionSelector'
import B2bCompanyClientSubActionSelector from './b2bCompanyClientSubActionSelector'
import B2bCompanyPolicyHistory from './b2bCompanyPolicyHistory'
import B2bCompanyClientProfileEdit from './b2bCompanyClientProfileEdit'
import {B2bCompanyGeneraliUri, B2bCompanyVerzekeringenUri} from '../environments'
import Modal from 'react-modal'

import i18n from 'lib/i18n'
const _ = i18n('clientZoom')

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 2
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '1em',
    },
}

const SubNav = ({currentId, items, onChange}) => (
	<div className={`${styles.headingDiv}`}>
		{Object.keys(items).map((moduleId) => (
			<div
				key={moduleId}
				className={`${styles.headingCell} info ${currentId === moduleId ? `${styles.active}` : ''}`}
				onClick={() => onChange(moduleId)}
			>
				{items[moduleId]}
			</div>
		))}
	</div>
)

@connect(
	state => {
		const clientId = state.b2bCompany.opened
		return ({
			subModule: state.b2bCompany.subModule,
			subModuleZoom: state.b2bCompany.subModuleZoom,
			clientId,
			data: state.b2bCompany.clientData[clientId] || {},
			isPhone: state.responsive.isPhone,
			currentClientAction: state.b2bCompany.currentClientAction,
			currentClientSubAction: state.b2bCompany.currentClientSubAction,
			selectedPolicy: state.b2bCompany.selectedPolicy,
			currentBrNr : state.b2bCompany.brNr,
			b2bCompanyCompany : state.b2bCompany.b2bCompanyCompany,
			b2bInsuranceCompany: state.b2b.b2bInsuranceCompany,
			isByContractNumber: state.b2b.isByContractNumber,
			policyActions: state.b2bCompany.policyActions,
			policySubActions: state.b2bCompany.policySubActions,
			b2bCompanyActionsDict: state.b2bCompany.b2bCompanyActionsDict,
			B2BTransactions : state.b2bCompany.B2BTransactions,
			transactionDetails: state.b2bCompany.transactionDetails,
			lang: state.app.lang,
			userId: state.app.userId,
			user: state.app.user,
			username: state.app.username,
			firstName: state.app.firstName,
			lastName: state.app.lastName,
            clientProfileForm: state.clientProfileForm
		})
	}
)
export default class B2bCompanyClientZoom extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		subModule: React.PropTypes.string,
		subModuleZoom: React.PropTypes.object,
		handleNewPolicy: React.PropTypes.func,
		clientId: React.PropTypes.string.isRequired,
		data: React.PropTypes.object,
		isPhone: React.PropTypes.bool,
		userId: React.PropTypes.string.isRequired,
		user: React.PropTypes.string.isRequired,
		username: React.PropTypes.string.isRequired,
		firstName: React.PropTypes.string.isRequired,
		lastName: React.PropTypes.string.isRequired,
	}

    constructor(props) {
        super(props)

        this.state = {modalIsOpen: false, modalSubmoduleName: ""}
    }

    openModal() {
        this.setState({modalIsOpen: !this.state.modalIsOpen})
    }

    leaveModal(subModuleName)
    {
        const {dispatch} = this.props
		const { isSetOpenedMode } = this.state

		if(isSetOpenedMode == true)
		{
			this.props.dispatch(setB2bCompanyOpened())
			this.setState({isSetOpenedMode: false})
		}
		else
		{
			dispatch(setB2bCompanySubModule(subModuleName))
		}

		this.openModal()
    }

    setSubModuleName(submoduleName)
    {
        this.setState({modalSubmoduleName: submoduleName});
    }

	setSubModule(subModuleName) {
		const clientProfileStatus = this.props.clientProfileForm.formStatus.sent
		const {dispatch} = this.props

		if(clientProfileStatus == false && this.props.subModule == 'edit-profile')
		{
			this.setSubModuleName(subModuleName)
			this.openModal()
		}
		else
		{
            dispatch(setB2bCompanySubModule(subModuleName))
		}
	}

	handleClose = () => {
		const clientProfileStatus = this.props.clientProfileForm.formStatus.sent
		const { isSetOpenedMode } = this.state

		if(clientProfileStatus == false && this.props.subModule == 'edit-profile')
		{
			this.setState({isSetOpenedMode: true})
			this.openModal()
		}
		else
		{
			this.props.dispatch(setB2bCompanyOpened())
		}
	}

	componentDidMount() {
		const {dispatch, subModule, clientId, data, b2bInsuranceCompany, b2bCompanyActionsDict} = this.props
		dispatch(setB2bCompanySelectedPolicy({}))
		dispatch(fetchB2bCompanyPolicyActionsDict())
		dispatch(fetchB2bCompanyPolicyActions(clientId, b2bInsuranceCompany.companyId || false)).then(
			resp => {
				if (!data.main) {
					dispatch(fetchClient(clientId, resp.b2bCompanyCompany && resp.b2bCompanyCompany.companyId || null))
				}
			}
		)
		if (!subModule) {
			this.setSubModule('profile')
		}
	}
	componentWillUnmount() {
		this.setSubModule('')
    }
    isNeedToUseXmlInUrlByCompanyId( companyId ) {
		switch( companyId ) {
			case '2320': { //vivium
				return false
			}
			case '2321': { // generali
				return true
			}
			return false
		}
    }
    getLanguageIdByCode( langCode ) {
		switch( langCode ) {
			case 'nl': { //vivium
				return 2
			}
			case 'fr': { // generali
				return 1
			}
			return 0
		}
	}
	getInsuranceCompanyUrlById( companyId ) {
		switch( companyId ) {
			case '2320': {
				return B2bCompanyVerzekeringenUri
			}
			case '2321': {
				return B2bCompanyGeneraliUri
			}
			return ''
		}
    }
    /**
     * This function will provide a correct encoded value for URIs,
     * when you do a remote request for an insurance company.
     * @param {*} value
     * @param {Number} companyId
     */
    getEncodedURIByCompanyId( value, companyId ) {
		switch( companyId ) {
			case '2320': { // vivium
				return encodeURIComponent(value)
            }
            case '2321': { // generali
                return encodeURIComponent(value)
            }
            // This below is the code what do the character encode switch for generali
            /* case '2321': { // generali
                let buff = null
                try {
                    buff = new buffer(value+"", 'utf-8')
                } catch( errr ) {
                    console.log( "Error when create buffer", errr )
                }

                let iso88591Value = null
                try {
                    iso88591Value = iconv.decode(buff, 'ISO-8859-1')
                } catch( errr ) {
                    console.log( "Error when iconv decode", errr )
                }

                return encodeURIComponent(iso88591Value)
			} */
			return encodeURIComponent(value)
		}
	}
	composeUriForB2bCompany = (b2bInfo, actionCategory, b2bCompanyCompany, policy = {}, recupCode = "") => {
		// b2bInfo: xml, transactionId, brokerAccount
        const {policySubActions, userId, user, username, firstName, lastName} = this.props
        const args = {}
        // usig xml tag as uri params if company Require
        if ( this.isNeedToUseXmlInUrlByCompanyId( b2bCompanyCompany.companyId ) ) {
            const pureTags = b2bInfo.xml && b2bInfo.xml.substr( b2bInfo.xml.indexOf(">")+1 ) || false
            const valuesFromXml = pureTags && xml2map.tojson( b2bInfo.xml ) || false
            if ( actionCategory && policySubActions[actionCategory] &&
                policySubActions[actionCategory].sendClientInfo === "true" &&
                pureTags
            ) {
                underscore.each( valuesFromXml, (value, key) => {
                    args[key] = value
                })
            }
		}
		args.oa = actionCategory && policySubActions[actionCategory].actionCode || ""
		args.d = actionCategory && policySubActions[actionCategory].actionDomain || ""
        args.rff = policy && policy.contractNumber || 0 // policyNumber ????
        args.txid = b2bInfo && b2bInfo.transactionId || ""
		args.Scenario = b2bCompanyCompany && b2bCompanyCompany.brokerCode || ""
		// used when recuperation for transaction
		args.RefTar = recupCode || ""
		args.LanguageScreen = lang && this.getLanguageIdByCode( lang ) || "2" // nl=2 fr=1 en=0
		args.Broker = b2bInfo && b2bInfo.brokerAccount || ""
		// userId arg what is not specified in documentation, but is necessary in practice
		args.brokerUserId = userId
		args.brokerUser = user
		args.brokerUsername = username
		args.brokerFirstName = firstName
		args.brokerLastName = lastName
		args.category = actionCategory || ""
		// compose uri params
		let params = []
		Object.keys(args).forEach((index) => {
            // please do not use lodash or underscore because the comparison of empty values do async shifting
            if (
                (
                    args[index] !== "" &&
                    !((args[index] instanceof Array) && args[index].length === 0) &&
                    !((typeof args[index] === "object") && Object.keys(args[index]).length === 0)
                ) || args[index] === 0
            ) {
                params.push(
                    (index + "=" + this.getEncodedURIByCompanyId(args[index], b2bCompanyCompany.companyId)) || ""
                )
            }
		})
		let uriParams = params.join('&')
		let urlDomain = this.getInsuranceCompanyUrlById( b2bCompanyCompany.companyId )
        let uri = urlDomain + (urlDomain.indexOf("?") === -1 ?  "?" :
            urlDomain.indexOf("?")+1 === urlDomain.length ? "" : "&"
        ) + uriParams


		window.open(uri, '_blank', 'noopener,noreferrer')
	}
	handleCheckPolicy = (policy) => {
		const {dispatch} = this.props
		dispatch(setB2bCompanySelectedPolicy(policy))
	}
	setB2bCompanyClientSubAction = () => {
		// nothing to do here, because the subaction selection does not require nothing action
	}
	handlePerformActions = (recupCode = '') => {
		/**
		 * Tamas update
		 * Added policySubActions since we need to get the same action code as the url
		 */
		const {dispatch, currentClientAction, currentClientSubAction, selectedPolicy, currentBrNr,
		b2bCompanyCompany, clientId, B2BTransactions, policySubActions} = this.props

		const args = {
			clientId: clientId || "",
			brokerNumber: currentBrNr || "",
			companyId: b2bCompanyCompany && b2bCompanyCompany.companyId || "",
			action: currentClientAction || "",
			category: currentClientSubAction || "",
			contractNumber: selectedPolicy && selectedPolicy.contractNumber || "",
			contractId: selectedPolicy && selectedPolicy.contractId || "",
			actionCode: policySubActions[currentClientSubAction].actionCode,
			b2bScenario: b2bCompanyCompany && b2bCompanyCompany.brokerCode || "",
			domain : currentClientSubAction && policySubActions[currentClientSubAction].actionDomain || "domainhere"
		}

		dispatch(B2bCompanyStartB2BAction(args))
		.then((b2bInfo) =>
		{
			this.composeUriForB2bCompany(b2bInfo, currentClientSubAction, b2bCompanyCompany,
				selectedPolicy, recupCode)
			dispatch(setB2bCompanyClientSubAction(""))
			dispatch(setB2bCompanyClientAction(""))
			dispatch(setB2bCompanySelectedPolicy({}))
		})
		.catch(
			err => {
				dispatch(setNotification(_('errorPerformActionOnPolicy'), 'error'))
			}
		)

    }

    /**
     * This function handle the recuperation button action, working like the real policy action but use data
     * from another sources, and does not start a new transaction, but create a record on server in authorization
     * collection with related data.
     */
	handlePerformRecuperation = (item) => {
        const {dispatch, b2bCompanyCompany, clientId, currentBrNr, currentClientAction, currentClientSubAction,
            policySubActions} = this.props
		const recupCode = item && item.recupCode || ''
		const b2bInfo = {
			brokerAccount: item.brokerAccount || "", // Or for a recuperation: From the JSON-item "brokerAccount" which will be returned in the getB2bTransactions Procedure.
			transactionId: item.transactionId || "",
			xml: false
		}
		const fakePolicy = {
			contractNumber: item.contractNumber
        }

        // not necessary to reset the actions, but here is the code to do that
        // dispatch(setB2bCompanyClientSubAction(""))
        // dispatch(setB2bCompanyClientAction(""))
        // dispatch(setB2bCompanySelectedPolicy({}))

        // this args are for save them in the authorization collection in mongodb
        const args = {
			recupCode: recupCode || "",
			transactionId: item.transactionId || "",
			clientId: clientId || "",
			brokerNumber: currentBrNr || "",
			companyId: b2bCompanyCompany && b2bCompanyCompany.companyId || "",
			action: "",
			category: "",
			contractNumber: item && item.contractNumber || "",
			contractId: item && item.contractId || "",
			actionCode: "",
			b2bScenario: b2bCompanyCompany && b2bCompanyCompany.brokerCode || "",
			domain : ""
        }

        dispatch(B2bCompanyStartB2BAction(args))
        .then((resp) => {

            const additionalStep = this.additionalActionsForRecuperation(args)

            // if we dont have to do additional step for generating url then we get a TRUE value.
            // else we get a promis where we have to wait to complete the service call.
            if( additionalStep === true ) {
                this.composeUriForB2bCompany(b2bInfo, item.category, b2bCompanyCompany,
                    fakePolicy, item.recupCode)
            } else
            if(typeof additionalStep.then == 'function') { // verify if it is a promise
                additionalStep.then(
                    resp => {
                        this.composeUriForB2bCompany(b2bInfo, item.category, b2bCompanyCompany,
                            fakePolicy, item.recupCode)
                    }
                ).catch(
                    err => dispatch(setNotification(_('errorPerformRecuperationOnPolicy'), 'error'))
                )
            }
        })
		.catch( err => {
			dispatch(setNotification(_('errorPerformActionOnPolicy'), 'error'))
		})
    }

    /**
     * This function make an extra step before redirecting to recuperation URI
     * Only some of the insurance companies are affected.
     */
    additionalActionsForRecuperation = (args) => {
        const {dispatch} = this.props
        switch( args.companyId ) {
			case '2320': {
                return dispatch(B2bCompanyB2bActionRecup(args))
			}
			case '2321': {
				return new Promise((res, rej) => { res(true) })
			}
			return new Promise((res, rej) => { res(true) })
		}
    }

	fetchActionNames = () => {
		const {policyActions, policySubActions, b2bCompanyActionsDict, lang} = this.props
		const policyActionsIds = Object.keys(policyActions || [])
		const labelValue = policyActionsIds && policyActionsIds.map(index => {
			let name = b2bCompanyActionsDict && b2bCompanyActionsDict['b2bCompanyActionTypes'] &&
				b2bCompanyActionsDict['b2bCompanyActionTypes'][policyActions[index].action] || false
				name = name && name[lang] || policyActions[index].action
			return {
				label: name,
				value: policyActions[index].action,
			}
		})
		let result = {}
		labelValue.forEach(
			(item) => { result[item.value] = item.label }
		)
		return result
	}
	fetchCategoryNames = () => {
		const {policySubActions, b2bCompanyActionsDict, lang} = this.props
		const policySubActionsIds = Object.keys(policySubActions || [])
		const labelValue = policySubActionsIds && policySubActionsIds.map(index => {
			let name = b2bCompanyActionsDict && b2bCompanyActionsDict['b2bCompanyActionsSubTypes'] &&
				b2bCompanyActionsDict['b2bCompanyActionsSubTypes'][policySubActions[index].category] || false
				name = name && name[lang] || policySubActions[index].category
			return {
				label: name,
				value: policySubActions[index].category,
			}
		})
		let result = {}
		labelValue.forEach(
			(item) => { result[item.value] = item.label }
		)
		return result
	}
	fetchStatusCodes = () => {
		const {b2bCompanyActionsDict, lang} = this.props
		let labelValue = []
		if (!underscore.isEmpty(b2bCompanyActionsDict) && !underscore.isEmpty(b2bCompanyActionsDict['b2bCompanyTransactionStatus'])) {
			const keys = Object.keys(b2bCompanyActionsDict['b2bCompanyTransactionStatus'])
			keys && keys.forEach((key) => {
				labelValue.push({
					label: b2bCompanyActionsDict['b2bCompanyTransactionStatus'][key][lang] || key,
					value: key,
				})
			})
		}
		let result = {}
		labelValue.forEach(
			(item) => { result[item.value] = item.label }
		)
		return result
	}
	canPerformAction = () => {
		const {currentClientAction, currentClientSubAction, selectedPolicy, transactionDetails, policySubActions} = this.props
		// option existence check and needsContract check
		const isNeededContract = !underscore.isEmpty(policySubActions)
			&& !underscore.isEmpty(policySubActions[currentClientSubAction])
			&& policySubActions[currentClientSubAction].needsContract === "true"
		// final button enabler logic
		const canPerform =
			!underscore.isEmpty(currentClientAction) && !underscore.isEmpty(currentClientSubAction)
			&& ((isNeededContract && !underscore.isEmpty(selectedPolicy)) || !isNeededContract)
			// when contract required or not
		return canPerform
    }
    refreshContractsList = () => {
        const {dispatch, b2bCompanyCompany, clientId} = this.props
        dispatch(fetchExistingClient(clientId, b2bCompanyCompany.companyId))
    }
    getHistory = () => {
        const {dispatch, b2bCompanyCompany, clientId} = this.props
        return dispatch(getB2bCompanyB2BTransactions({companyId: b2bCompanyCompany.companyId,clientId: clientId}))
    }
	render() {
		const {subModule, subModuleZoom, data, isPhone, clientId, subscriberPopup, currentClientAction,
			currentClientSubAction, B2BTransactions, b2bCompanyActionsDict, b2bCompanyCompany, isByContractNumber} = this.props
		// second perform action button is always shown but is enabled when everything is selected, or the action is new policy
		let output, canPerformAction = this.canPerformAction()
		const actionNames = this.fetchActionNames()
		const categoryNames = this.fetchCategoryNames()
		const statusNames = this.fetchStatusCodes()
		const setSubModule = (subModuleName) => {
			this.setSubModule(subModuleName)
		}
		const modalIsOpen = this.state.modalIsOpen
		const modalSubmoduleName = this.state.modalSubmoduleName

		if (!data.main) { return false }
		switch (subModule) {
			case 'profile':
				output = (
					<div>
						<B2bCompanyClientProfile
							{...{
								clientId,
								data,
							}}
						/>
						<h3>{_('policies')}</h3>
						<div className={styles.actionSelectorsWrap}>
							<span className={styles.inputGroup}>
								<label className={styles.label}>
									{_('clientAction')}
								</label>
								<B2bCompanyClientActionSelector
										styleName={styles.actionSelector}
										actionNames={actionNames}
										currentClientAction = {currentClientAction}
								/>
							</span>
							<span className={styles.inputGroup}>
								<label className={styles.label}>
									{_('clientSubAction')}
								</label>
								<B2bCompanyClientSubActionSelector
									styleName={styles.actionSelector}
									categoryNames={categoryNames}
									currentClientSubAction = {currentClientSubAction}
								/>
							</span>

							{currentClientAction*1 == 1 &&
								<span className={styles.inputGroup}>
									<button
										disabled={!canPerformAction}
										className={styles.greyButton}
										onClick={(e) => this.handlePerformActions("")}
										type="button"
									>
										{_('performActions')}
									</button>
								</span>
							}
						</div>
                        <B2bCompanyClientContracts
                            onSelectEdit = {this.handleCheckPolicy}
                            onRefresh = {this.refreshContractsList}
                        />
						{underscore.isEmpty(data.contractIds) && isByContractNumber &&
							<div className={styles.actionSelectorsWrap}>
								<div>{_("noContractForThisB2bCompany")}</div>
							</div> || null
						}
						{underscore.isEmpty(data.contractIds) && currentClientAction
							&& currentClientSubAction && !canPerformAction &&
							<div className={styles.actionSelectorsWrap}>
								{ <div>{_("noActionWithoutContract")}</div>}
							</div>
						}
						{currentClientAction && currentClientAction*1 !== 1 && !underscore.isEmpty(data.contractIds) &&
							<div className={styles.actionSelectorsWrapRight}>
								<span className={styles.inputGroup}>
										<button
											disabled={!canPerformAction}
											className={styles.greyButton}
											onClick={(e) => this.handlePerformActions("")}
											type="button"
										>
											{_('performActions')}
										</button>
								</span>
							</div>
						}
						{!underscore.isEmpty(b2bCompanyActionsDict) &&
							<B2bCompanyPolicyHistory
								data={B2BTransactions}
								actionNames = {actionNames}
								categoryNames = {categoryNames}
								statusNames = {statusNames}
                                handlePerformRecuperation = {this.handlePerformRecuperation}
                                getHistory = {this.getHistory}
                                getContracts = {this.refreshContractsList}
							/>
						}
					</div>
				)
				break
            case 'edit-profile':
                output = (
					<B2bCompanyClientProfileEdit
                        {...{
                            clientId,
                            data,
                        }}
						setSubModule={setSubModule}
					/>
                )
                break;
			default:
				output = <div>Unknown submodule!</div>
				break
		}
		return (
			<div className={styles.b2bCompanyClientZoomContainer}>
				<div className={styles.content}>

					<div className={styles.mainTitleDiv}>
						<div className={styles.mainTitleContainer}>
							<h2 className={styles.mainTitle}>{b2bCompanyCompany && b2bCompanyCompany.insuranceCompany || _('InsuranceCompany')}</h2>
							<h3>{_('b2bCompanySubtitle')}</h3>
						</div>
						{!isPhone &&
							<div className={styles.moduleControls}>
								<div onClick={this.handleClose} className={styles.greyButton}>
									{_('backToList')}
								</div>
							</div>
						}
					</div>
					<div className={styles.clientZoom}>
						<div className={styles.subNav}>
							{/*<SubNav
								currentId={subModule}
								items={{
									profile: _('profile'),
								}}
								onChange={id => this.setSubModule(id)}
							/>*/}
						</div>
						<div className={styles.moduleWrap}>
							{output}
						</div>
					</div>
				</div>

				<Modal
					isOpen={modalIsOpen}
					style={customStyles}
					contentLabel="Modal"
				>
					<div className={styles.verifyModalContent}>
						<span className={styles.title}>{_('clientProfileLeavePopup')}</span>
						<span className={styles.message}>{_('clientProfileLeavePopupMessage')}</span>
						<div className={styles.verifyModalButtons}>
					<span
						onClick={() => this.openModal()}
						className={styles.cancel}
					>
						{_("cancel")}
					</span>
							<input
								onClick={() => this.leaveModal(modalSubmoduleName)}
								type="button"
								className={styles.greyButton + " enabled"}
								value={_("clientProfileLeaveOkButton")}
							/>
						</div>
					</div>
				</Modal>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/b2bCompany/b2bCompanyClientZoom.jsx